export default "/packs/images/pdf~3a0202e95ffab0c228065a6ef3399b4a.svg";